import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(private _router: Router) { }

  ngOnInit(): void { }

  onManageuserClick() {
    this._router.navigate(['manageusers']);
  }

  onCDLTHomeClick() {
    this._router.navigate(['home']);
  }

  onFAQClick() {
    this._router.navigate(['faq']);
  }

  onDemoClick() {
    this._router.navigate(['demo']);
  }
}
